import { render } from "./Main.vue?vue&type=template&id=3f654cdd"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"

import exportComponent from "C:\\__MRYNK\\_2022\\19dnl008lot-stop45\\frontend2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__